module.exports = "\nuniform vec3 u_color;\nuniform vec3 u_ambient;\nuniform vec3 u_lightPos;\nuniform vec3 u_lightCol;\n\nvarying vec3 f_position;\nvarying vec3 f_normal;\n\nvoid main() {\n    vec4 color = vec4(u_color, 1.0);\n\n    float d = clamp(dot(f_normal, normalize(u_lightPos - f_position)), 0.0, 1.0);\n    gl_FragColor = vec4(d * color.rgb * u_lightCol + 0.2 * u_ambient, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/frag.glsl
// module id = 13
// module chunks = 0